var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable } from 'mobx';
import { runtime } from '../../../runtime/Runtime';
import { MobxPrepone } from '../../../../utils/mobx/decorators/MobxPrepone';
import { AttachedImage } from '../AttachedImage';
export class ImageImg {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get image() {
        return this.parent;
    }
    get persistentImage() {
        if (this.image instanceof AttachedImage) {
            return this.image.trait;
        }
        return this.image;
    }
    get img() {
        return this.image.essence.valueOf.imageFile || this.lazyImgTrait.value;
    }
    get localImg() {
        return this.image.essence.local.valueOf.imageFile || this.lazyImgTrait.value;
    }
    get lazyImgTrait() {
        return MobxPrepone.provideInstant({
            owner: this,
            instantFactory: this.createNewImgTrait,
            modifyState: newTrait => this.persistentImage.essence.aspectCreateTrait.addTraitToBeginning(newTrait),
        });
    }
    get imgAt() {
        return this.image.essence.activeOf.imageFile || this.image.essence.aspectAttached.toAttached(this.lazyImgTrait);
    }
    createNewImgTrait() {
        return runtime.class.Trait.fromSerialized({
            parent: this.persistentImage.essence,
            key: 'imageFile',
            value: { type: 'img' },
        });
    }
}
__decorate([
    computed
], ImageImg.prototype, "img", null);
__decorate([
    computed
], ImageImg.prototype, "localImg", null);
__decorate([
    computed
], ImageImg.prototype, "imgAt", null);
__decorate([
    action.bound
], ImageImg.prototype, "createNewImgTrait", null);
